export default {
    cacheKeys: {
        resumeReviewerId: 'ENRICH_COACHING_PLATFORM_RESUME_REVIEWER_ID',
        authToken: 'ENRICH_COACHING_PLATFORM_TOKEN',
        userId: 'ENRICH_COACHING_PLATFORM_USER_ID',
        coachId: 'ENRICH_COACHING_PLATFORM_COACH_ID',
        welcomeCallCoachId: 'ENRICH_COACHING_PLATFORM_WELCOME_CALL_COACH_ID',
    },
    clientRestrictedCandidacyStatuses: [
        'assigned',
        'interested',
        'missed_apply_deadline',
        'applied',
    ],
    closedCandidacyStatuses: [
        'not_interested',
        'missed_match_deadline',
        'missed_apply_deadline',
        'application_rejected',
        'offer_rejected',
        'closed',
    ],
    communicationLevels: [
        { id: 1, name: 'Low' },
        { id: 2, name: 'Average' },
        { id: 3, name: 'High' },
    ],
    eventTypes: {
        application_approved: 'application_approved',
        application_denied: 'application_denied',
        application_waitlisted: 'application_waitlisted',
        contact_deactivated: 'contact_deactivated',
        contact_offboarded: 'contact_offboarded',
        document_submitted: 'document_submitted',
        job_matched: 'job_matched',
        job_interested: 'job_interested',
        job_missed_apply_deadline: 'job_missed_apply_deadline',
        job_missed_match_deadline: 'job_missed_match_deadline',
        job_not_interested: 'job_not_interested',
        job_not_sure: 'job_not_sure',
        job_applied: 'job_applied',
        job_received_assessment: 'job_received_assessment',
        job_received_interview: 'job_received_interview',
        job_received_offer: 'job_received_offer',
        job_application_rejected: 'job_application_rejected',
        job_accepted_offer: 'job_accepted_offer',
        job_rejected_offer: 'job_rejected_offer',
        meeting_canceled: 'meeting_canceled',
        meeting_no_show: 'meeting_no_show',
        meeting_scheduled: 'meeting_scheduled',
        portal_account_created: 'portal_account_created',
        portal_login: 'portal_login',
        resume_approved: 'resume_approved',
        resume_edited: 'resume_edited',
        resume_edits_requested: 'resume_edits_requested',
        resume_submitted: 'resume_submitted',
        client_message_sent: 'client_message_sent',
    },
    nonActiveStudentStatuses: [
        'accepted',
        'applied',
        'denied',
        'inactive',
        'international',
        'offboarded',
        'waitlisted',
    ],
    jobStatusOptions: ['demo', 'preparing', 'open'],
    jobStatusFilterOptions: [
        { value: 'demo', label: 'Demo' },
        { value: 'preparing', label: 'Future Job' },
        { value: 'open', label: 'Open' },
    ],
    jobDegreeTypes: [
        "associate's degree",
        "bachelor's degree",
        "master's degree",
        'other',
    ],
    weightOptions: [
        { label: 'No Importance', value: 0 },
        { label: 'Low Importance', value: 25 },
        { label: 'Medium Importance', value: 50 },
        { label: 'High Importance', value: 75 },
        { label: 'Must Have', value: 100 },
    ],
};
